// Cookiefreies Analytics (Umami). Aktiv nur, wenn VITE_UMAMI_WEBSITE_ID zur
// Build-Zeit gesetzt ist (fly.toml [build.args] → Dockerfile ARG). Ohne ID
// passiert nichts — lokal und in Previews bleibt es still.
declare global {
  interface Window {
    umami?: { track: (name: string, data?: Record<string, string | number | boolean>) => void };
  }
}

const WEBSITE_ID = import.meta.env.VITE_UMAMI_WEBSITE_ID as string | undefined;
const SCRIPT_SRC = (import.meta.env.VITE_UMAMI_SRC as string | undefined) ?? "https://cloud.umami.is/script.js";

export function initAnalytics(): void {
  if (!WEBSITE_ID || typeof document === "undefined") return;
  if (document.querySelector("script[data-website-id]")) return;
  const s = document.createElement("script");
  s.defer = true;
  s.src = SCRIPT_SRC;
  s.dataset.websiteId = WEBSITE_ID;
  // Nur die Produktionsdomain zählen (kein localhost / petloc.fly.dev).
  s.dataset.domains = "petloc.co";
  document.head.appendChild(s);
}

/** Custom-Event (z.B. order_started). No-op, wenn Analytics nicht geladen ist. */
export function track(name: string, data?: Record<string, string | number | boolean>): void {
  try {
    window.umami?.track(name, data);
  } catch {
    /* ignore */
  }
}
